module.exports = __webpack_public_path__ + "img/shape3.af2189c0.png";